import {
  showErrorMsg,
  showRequestSubmitted,
  showSuccessMsg,
} from "../utils/toast";
import api from "./api";
import { Log } from "./services";

// --------------- API Calls for Payment Hosts ----------------------- //

// Payment Methods

export function getPaymentMethods({ setResponse, setLoaded, filter }) {
  const { page, page_size, ...restFilter } = filter || {};
  const queryParams = new URLSearchParams();
  if (page) queryParams.append('page', page);
  if (page_size) queryParams.append('page_size', page_size);
  const queryString = queryParams.toString() ? `?${queryParams.toString()}` : "";
  const url = `/payment/payment_method/filter/${queryString}`;
  api
    .post(url, { ...restFilter })
    .then((res) => {
      setResponse(res.data);
    })
    .catch((error) => {
      showErrorMsg()
      Log.error(url, null, error)
    })
    .finally(() => setLoaded?.(true));
}

export async function getPaymentMethodFilterConditions(setResponse, setLoaded) {
  const url = "/payment/payment_method/filter_conditions/";
  await api
    .get(url)
    .then((res) => {
      if (res.status === 200) {
        setResponse(res.data);
      } else {
        showErrorMsg(res?.data.toString())
      }
    })
    .catch(() => showErrorMsg())
    .finally(() => setLoaded(true))
}

export function getPaymentMethodEvents({ setResponse, setLoaded, filter }) {
  const { page, page_size, ...restFilter } = filter || {};
  const queryParams = new URLSearchParams();
  if (page) queryParams.append('page', page);
  if (page_size) queryParams.append('page_size', page_size);
  const queryString = queryParams.toString() ? `?${queryParams.toString()}` : "";
  const url = `/payment/payment_method_event/filter/${queryString}`;
  api
    .post(url, { ...restFilter })
    .then((res) => {
      setResponse(res.data);
      setLoaded(true);
    })
    .catch(() => showErrorMsg());
}

export function getPaymentMethodEventsDetails(id, setResponse, setLoaded) {
  const url = `/payment/payment_method_event/details/${id}/`;
  api
    .get(url)
    .then((res) => {
      setResponse(res.data);
      setLoaded(true);
    })
    .catch(() => showErrorMsg());
}

export async function PaymentMethodAction(
  action,
  { selectedId, paymentMethod, action_message } = ""
) {
  const url = `/payment/payment_method/action/`;
  const params = {
    action: action,
    pk: selectedId,
    name: paymentMethod,
    action_message
  }
  await api
    .post(url, {
      action: action,
      pk: selectedId,
      name: paymentMethod,
      action_message
    })
    .then((res) => {
      if (res.status === 200 || res.status === 201) {
        showSuccessMsg(res.data?.detail);
        // window.location.reload();
      } else if (res.status === 404) {
        showErrorMsg(res?.data.toString());
        Log.error(url, params, res)
      } else {
        showErrorMsg(res.data?.detail);
        Log.error(url, params, res);
      }
    })
    .catch((error) => {
      showErrorMsg()
      Log.error(url, params, error)
    });
}

export function getActivePaymentMethods(setResponse, setLoaded) {
  const url = "/payment/payment_method/dropdown/";
  api
    .get(url)
    .then((res) => {
      setResponse(res.data);
      setLoaded(true);
    })
    .catch(() => showErrorMsg());
}

// Pending Payment method
export function getPendingPaymentMethods({ setResponse, setLoaded, filter }) {
  const { page, page_size, ...restFilter } = filter || {};
  const queryParams = new URLSearchParams();
  if (page) queryParams.append('page', page);
  if (page_size) queryParams.append('page_size', page_size);
  const queryString = queryParams.toString() ? `?${queryParams.toString()}` : "";
  const url = `/payment/pending_payment_method/filter/${queryString}`;
  api
    .post(url, { ...restFilter })
    .then((res) => {
      setResponse(res.data);
    })
    .catch((error) => {
      showErrorMsg()
      Log.error(url, null, error)
    })
    .finally(() => setLoaded?.(true));
}

export function getPaymentMethodDetails(id, setResponse, setLoaded) {
  const url = `/payment/payment_method/details/${id}/`;
  api
    .get(url)
    .then((res) => {
      setResponse(res.data);
    })
    .catch((error) => {
      if (error.response?.status === 401) {
        showErrorMsg(error.response?.data?.detail);
      } else if (error.response?.status === 404) {
        showErrorMsg(error.response?.data);
      } else {
        showErrorMsg(error.message);
      }
    })
    .finally(() => setLoaded(true));
}

export async function getPaymentMethodWithActions(id, setResponse, setLoaded) {
  const url = `/payment/pending_payment_method/details/${id}/`;
  await api
    .get(url)
    .then((res) => {
      setResponse(res.data);
    })
    .catch((error) => {
      if (error.response?.status === 401) {
        showErrorMsg(error.response?.data?.detail);
      } else if (error.response?.status === 404) {
        showErrorMsg(error.response?.data);
      } else {
        showErrorMsg(error.message);
      }
    })
    .finally(() => setLoaded(true));
}

export async function PendingPaymentMethodAction(
  id,
  action,
  setPaymentMethodList,
  setLoaded,
  comment = ""
) {
  const url = `/payment/pending_payment_method/approver/`;
  return await api
    .post(url, {
      pk: id,
      choice: action,
      reject_message: comment,
    })
    .then((res) => {
      if (res.status === 200 || res.status === 201) {
        showSuccessMsg(res.data?.detail);
        setLoaded(false);
        getPendingPaymentMethods({ setResponse: setPaymentMethodList, setLoaded });
      } else showErrorMsg(res.data);
    })
    .catch((error) => {
      if (error.response?.status === 401) {
        showErrorMsg(error.response?.data?.detail);
      } else if (error.response?.status === 404) {
        showErrorMsg(error.response?.data);
      } else {
        showErrorMsg(error.message);
      }
    });
}

// Payment Brands

export function getPaymentBrands({ setResponse, setLoaded, filter }) {
  const { page, page_size, ...restFilter } = filter || {};
  const queryParams = new URLSearchParams();
  if (page) queryParams.append('page', page);
  if (page_size) queryParams.append('page_size', page_size);
  const queryString = queryParams.toString() ? `?${queryParams.toString()}` : "";
  const url = `/payment/payment_brand/filter/${queryString}`;
  api
    .post(url, { ...restFilter })
    .then((res) => {
      setResponse(res.data);
    })
    .catch((error) => {
      showErrorMsg()
      Log.error(url, null, error)
    })
    .finally(() => setLoaded?.(true));
}

export function getPendingPaymentBrands({ setResponse, setLoaded, filter }) {
  const { page, page_size, ...restFilter } = filter || {};
  const queryParams = new URLSearchParams();
  if (page) queryParams.append('page', page);
  if (page_size) queryParams.append('page_size', page_size);
  const queryString = queryParams.toString() ? `?${queryParams.toString()}` : "";
  const url = `/payment/pending_payment_brand/filter/${queryString}`;
  api
    .post(url, { ...restFilter })
    .then((res) => {
      setResponse(res.data);
    })
    .catch((error) => {
      showErrorMsg()
      Log.error(url, null, error)
    })
    .finally(() => setLoaded?.(true));
}

export function getPaymentBrandDetails(id, setResponse, setLoaded) {
  const url = `/payment/payment_brand/details/${id}/`;
  api
    .get(url)
    .then((res) => {
      setResponse(res.data);
    })
    .catch((error) => {
      if (error.response?.status === 401) {
        showErrorMsg(error.response?.data?.detail);
      } else if (error.response?.status === 404) {
        showErrorMsg(error.response?.data);
      } else {
        showErrorMsg(error.message);
      }
    })
    .finally(() => setLoaded(true));
}

export async function getPaymentBrandWithActions(id, setResponse, setLoaded) {
  const url = `/payment/pending_payment_brand/details/${id}/`;
  await api
    .get(url)
    .then((res) => {
      setResponse(res.data);
    })
    .catch((error) => {
      if (error.response?.status === 401) {
        showErrorMsg(error.response?.data?.detail);
      } else if (error.response?.status === 404) {
        showErrorMsg(error.response?.data);
      } else {
        showErrorMsg(error.message);
      }
    })
    .finally(() => setLoaded(true));
}

export async function PendingPaymentBrandAction(
  id,
  action,
  setPaymentBrandList,
  setLoaded,
  comment = ""
) {
  const url = `/payment/pending_payment_brand/approver/`;
  return await api
    .post(url, {
      pk: id,
      choice: action,
      reject_message: comment,
    })
    .then((res) => {
      if (res.status === 200 || res.status === 201) {
        showSuccessMsg(res.data?.detail);
        setLoaded(false);
        getPendingPaymentBrands({ setResponse: setPaymentBrandList, setLoaded });
      } else showErrorMsg(res.data);
    })
    .catch((error) => {
      if (error.response?.status === 401) {
        showErrorMsg(error.response?.data?.detail);
      } else if (error.response?.status === 404) {
        showErrorMsg(error.response?.data);
      } else {
        showErrorMsg(error.message);
      }
    });
}

export async function getPaymentBrandFilterConditions(setResponse, setLoaded) {
  const url = "/payment/payment_brand/filter_conditions/";
  await api
    .get(url)
    .then((res) => {
      setResponse(res.data);
    })
    .catch(() => showErrorMsg())
    .finally(() => setLoaded(true))
}

export function getPaymentBrandEvent({ setResponse, setLoaded, filter }) {
  const { page, page_size, ...restFilter } = filter || {};
  const queryParams = new URLSearchParams();
  if (page) queryParams.append('page', page);
  if (page_size) queryParams.append('page_size', page_size);
  const queryString = queryParams.toString() ? `?${queryParams.toString()}` : "";
  const url = `/payment/payment_brand_event/filter/${queryString}`;
  api
    .post(url, { ...restFilter })
    .then((res) => {
      setResponse(res.data);
      setLoaded(true);
    })
    .catch(() => showErrorMsg());
}

export function getPaymentBrandEventsDetails(id, setResponse, setLoaded) {
  const url = `/payment/payment_brand_event/details/${id}/`;
  api
    .get(url)
    .then((res) => {
      setResponse(res.data);
      setLoaded(true);
    })
    .catch(() => showErrorMsg());
}

export function getActivePaymentBrands(setResponse, setLoaded) {
  const url = "/payment/payment_brand/filter/?page_size=1000";
  api
    .post(url, { is_active: true })
    .then((res) => {
      setResponse(res.data.results || res.data);
      setLoaded(true);
    })
    .catch(() => showErrorMsg());
}

export function getCurrencyList(setResponse, setLoaded) {
  const url = `/payment/payment_host_info/retrieve_currency/`;
  api
    .get(url)
    .then((res) => {
      setResponse(res.data);
      setLoaded(true);
    })
    .catch(() => showErrorMsg());
}

export async function getCurrencyListByHost(params, setResponse) {
  const url = `/payment/payment_host/currency_by_host/`;
  return await api
    .post(url, params)
    .then((res) => {
      setResponse(res.data);
    })
    .catch(() => showErrorMsg());
}

export async function paymentBrandAction(action, { pk, name, payment_method, action_message } = "", onSuccessCallback = null) {
  const url = `/payment/payment_brand/action/`;
  const params = {
    action: action,
    pk: pk,
    name: name,
    payment_method: payment_method,
    action_message,
  };
  let success = false;
  await api
    .post(url, params)
    .then((res) => {
      if (res.status === 200 || res.status === 201) {
        showSuccessMsg(res.data?.detail);
        // window.location.reload();
        if (onSuccessCallback) {
          onSuccessCallback(res.data);
        }
        success = true;
      } else if (res.status === 404) {
        showErrorMsg(res?.data.toString());
        Log.error(url, params, res)
      } else {
        showErrorMsg(res.data?.detail);
        Log.error(url, params, res);
      }
    })
    .catch((error) => {
      showErrorMsg()
      Log.error(url, params, error)
    });
  return success;
}

//Payment Hosts

export function getPaymentHosts({ setResponse, setLoaded, filter }) {
  const { page, page_size, ...restFilter } = filter || {};
  const queryParams = new URLSearchParams();
  if (page) queryParams.append('page', page);
  if (page_size) queryParams.append('page_size', page_size);
  const queryString = queryParams.toString() ? `?${queryParams.toString()}` : "";
  const url = `/payment/payment_host/filter/${queryString}`;
  api
    .post(url, { ...restFilter })
    .then((res) => {
      if (res.status === 200) {
        setResponse(res.data);
      } else {
        showErrorMsg(res?.data.toString())
      }
    })
    .catch((error) => {
      showErrorMsg()
      Log.error(url, restFilter, error)
    })
    .finally(() => setLoaded?.(true));
}

export async function getPaymentHostFilterConditions(setResponse, setLoaded) {
  const url = "/payment/payment_host/filter_conditions/";
  await api
    .get(url)
    .then((res) => {
      setResponse(res.data);
      setLoaded(true);
    })
    .catch(() => showErrorMsg());
}

export function getHistoryPaymentBrands({ setResponse, setLoaded, filter }) {
  const { page, page_size, ...restFilter } = filter || {};
  const queryParams = new URLSearchParams();
  if (page) queryParams.append('page', page);
  if (page_size) queryParams.append('page_size', page_size);
  const queryString = queryParams.toString() ? `?${queryParams.toString()}` : "";
  const url = `/payment/pending_payment_brand/filter_history/${queryString}`;
  api
    .post(url, { ...restFilter })
    .then((res) => {
      setResponse(res.data);
    })
    .catch(() => showErrorMsg())
    .finally(() => setLoaded?.(true));
}

export function getHistoryPaymentMethods({ setResponse, setLoaded, filter }) {
  const { page, page_size, ...restFilter } = filter || {};
  const queryParams = new URLSearchParams();
  if (page) queryParams.append('page', page);
  if (page_size) queryParams.append('page_size', page_size);
  const queryString = queryParams.toString() ? `?${queryParams.toString()}` : "";
  const url = `/payment/pending_payment_method/filter_history/${queryString}`;
  api
    .post(url, { ...restFilter })
    .then((res) => {
      setResponse(res.data);
    })
    .catch(() => showErrorMsg())
    .finally(() => setLoaded?.(true));
}

export function getHistoryPaymentHosts({ setResponse, setLoaded, filter }) {
  const { page, page_size, ...restFilter } = filter || {};
  const queryParams = new URLSearchParams();
  if (page) queryParams.append('page', page);
  if (page_size) queryParams.append('page_size', page_size);
  const queryString = queryParams.toString() ? `?${queryParams.toString()}` : "";
  const url = `/payment/pending_payment_host/filter_history/${queryString}`;
  api
    .post(url, { ...restFilter })
    .then((res) => {
      setResponse(res.data);
    })
    .catch(() => showErrorMsg())
    .finally(() => setLoaded?.(true));
}

export function getPaymentHostsEvent({ setResponse, setLoaded, filter }) {
  const { page, page_size, ...restFilter } = filter || {};
  const queryParams = new URLSearchParams();
  if (page) queryParams.append('page', page);
  if (page_size) queryParams.append('page_size', page_size);
  const queryString = queryParams.toString() ? `?${queryParams.toString()}` : "";
  const url = `/payment/payment_host_event/filter/${queryString}`;
  api
    .post(url, { ...restFilter })
    .then((res) => {
      setResponse(res.data);
    })
    .catch(() => showErrorMsg())
    .finally(() => setLoaded?.(true));
}

export function getPaymentHostEventsDetails(id, setResponse, setLoaded) {
  const url = `/payment/payment_host_event/details/${id}/`;
  api
    .get(url)
    .then((res) => {
      setResponse(res.data);
      setLoaded(true);
    })
    .catch(() => showErrorMsg());
}

export async function paymentHostAction(
  action,
  { selectedId, name, payment_brand, currency_list, data, reason } = "",
  cb
) {
  const url = `/payment/payment_host/action/`;
  const params = {
    action: action,
    pk: selectedId,
    name: name,
    payment_brand: payment_brand,
    currency_list: currency_list,
    data: data,
    action_message: reason,
  };
  await api
    .post(url, {
      action: action,
      pk: selectedId,
      name: name,
      payment_brand: payment_brand,
      currency_list: currency_list,
      data: data,
      action_message: reason,
    })
    .then((res) => {
      if (res.status === 200 || res.status === 201) {
        const detail = res?.data?.detail;
        showSuccessMsg(detail);
        cb?.()
      } else if (res.status === 404) {
        showErrorMsg(res?.data.toString());
        Log.error(url, params, res)
      } else {
        showErrorMsg(res.data?.detail);
        Log.error(url, params, res);
      }
    })
    .catch((error) => {
      showErrorMsg()
      Log.error(url, params, error)
    });
}

export function getPendingPaymentHosts(setResponse, setLoaded, fParams) {
  const { page, page_size, ...restFilter } = fParams || {};
  const queryParams = new URLSearchParams();
  if (page) queryParams.append('page', page);
  if (page_size) queryParams.append('page_size', page_size);
  const queryString = queryParams.toString() ? `?${queryParams.toString()}` : "";
  const url = `/payment/pending_payment_host/filter/${queryString}`;
  api
    .post(url, { ...restFilter })
    .then((res) => {
      setResponse(res.data);
    })
    .catch((error) => {
      showErrorMsg()
      Log.error(url, null, error)
    })
    .finally(() => setLoaded?.(true));
}

export function getPaymentHostDetails(id, setResponse, setLoaded) {
  const url = `/payment/payment_host/details/${id}/`;
  api
    .get(url)
    .then((res) => {
      setResponse(res.data);
    })
    .catch((error) => {
      if (error.response?.status === 401) {
        showErrorMsg(error.response?.data?.detail);
      } else if (error.response?.status === 404) {
        showErrorMsg(error.response?.data);
      } else {
        showErrorMsg(error.message);
      }
    })
    .finally(() => setLoaded(true));
}

export async function getPaymentHostWithActions(id, setResponse, setLoaded) {
  const url = `/payment/pending_payment_host/details/${id}/`;
  await api
    .get(url)
    .then((res) => {
      setResponse(res.data);
    })
    .catch((error) => {
      if (error.response?.status === 401) {
        showErrorMsg(error.response?.data?.detail);
      } else if (error.response?.status === 404) {
        showErrorMsg(error.response?.data);
      } else {
        showErrorMsg(error.message);
      }
    })
    .finally(() => setLoaded(true));
}

export async function PendingPaymentHostAction(
  id,
  action,
  setPaymentBrandList,
  setLoaded,
  comment = ""
) {
  const url = `/payment/pending_payment_host/approver/`;
  return await api
    .post(url, {
      pk: id,
      choice: action,
      reject_message: comment,
    })
    .then((res) => {
      if (res.status === 200 || res.status === 201) {
        showSuccessMsg(res.data?.detail);
        setLoaded(false);
        getPendingPaymentHosts(setPaymentBrandList, setLoaded);
      } else showErrorMsg(res.data);
    })
    .catch((error) => {
      if (error.response?.status === 401) {
        showErrorMsg(error.response?.data?.detail);
      } else if (error.response?.status === 404) {
        showErrorMsg(error.response?.data);
      } else {
        showErrorMsg(error.message);
      }
    });
}

//Payment HostInfo
export function getPaymentHostInfo(setResponse, setLoaded) {
  const url = "/payment/payment_host_info/filter/";
  api
    .post(url)
    .then((res) => {
      setResponse(res.data);
      setLoaded(true);
    })
    .catch(() => showErrorMsg());
}


